.dealerLocationContainer {
  display: flex;
  background: #12253e;
  border-radius: 8px;

  .dealerLocationInfo-content {
    flex: 1;

    .text-muted {
      display: inline-block;
      max-width: 56%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .dealerLocationInfo-actions {
    align-self: flex-end;
    white-space: nowrap;
    display: flex;
  }

  .dealerLocationInfo-btn {
    padding: 0.25rem 1rem;
  }

  .dealerLocationInfo-btn {
    text-decoration: none;
    color: white;
  }
}
